import { DiscussionInfo } from '@/models/forumAPI/DiscussionModel';

export interface DiscussionState {
  discussions: { [key: string]: DiscussionInfo };
  paginatedDiscussions: { [key: string]: DiscussionInfo };
}

const state: DiscussionState = {
  discussions: {},
  paginatedDiscussions: {},
};

export default state;
